import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

export const addAdjustmentSchema = yup.object({
	amount: yup
		.number()
		.required("金額は必須です")
		.positive("金額は正の値を入力してください")
		.integer("金額は整数で入力してください"),
	isAmountKindPayout: yup
		.boolean()
		.transform((value) => value === "true" || value === true)
		.required("支払い種別は必須です"),
	name: yup.string().required("調整名は必須です"),
	memo: yup.string().optional().nullable(),
})

export type AddAdjustmentFormData = yup.InferType<typeof addAdjustmentSchema>

export const addAdjustmentResolver = yupResolver(addAdjustmentSchema)
